import {ChangeDetectionStrategy, Component, inject, input} from '@angular/core';
import {RouterLink} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {PATHS} from '../../../const/paths';
import {MonAbonnementStore} from '../../../shared/services/mon-abonnement.store';
import {DroitsRefreshService} from '../../../shared/services/droits-refresh.service';

/**
 * Bouton d'action d'abonnement : « Gérer mon abonnement » (portail Odoo, nouvel onglet) si Odoo le
 * propose, sinon « Contacter le support ». Au retour sur l'onglet après la gestion de l'abonnement, les
 * droits sont rafraîchis (filet de sécurité si l'événement temps réel n'a pas été reçu). Gating UI
 * uniquement : le lien est validé côté serveur.
 */
@Component({
  selector: 'app-subscription-action',
  standalone: true,
  imports: [TranslateModule, RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {'(document:visibilitychange)': 'onVisibilityChange()'},
  template: `
    @if (store.loaded()) {
      @if (store.managementUrl(); as url) {
        <a class="btn btn-sm {{ btnClass() }}" [href]="url" target="_blank" rel="noopener noreferrer" (click)="onManage()">
          <i class="fa-solid fa-arrow-up-right-from-square me-2" aria-hidden="true"></i>
          {{ 'subscription.action.manage' | translate }}
        </a>
      } @else {
        <a class="btn btn-sm {{ btnClass() }}" [routerLink]="supportLink">
          <i class="fa-solid fa-headset me-2" aria-hidden="true"></i>
          {{ 'subscription.action.support' | translate }}
        </a>
      }
    }
  `,
})
export class SubscriptionActionComponent {
  /** Classe Bootstrap du bouton (ex. `btn-danger` dans un bandeau critique). */
  readonly btnClass = input('btn-outline-dark');

  protected readonly store = inject(MonAbonnementStore);
  private readonly droits = inject(DroitsRefreshService);
  protected readonly supportLink = ['/', PATHS.SUPPORT];

  /** Vrai entre l'ouverture du portail Odoo et le retour sur l'onglet Clésame. */
  private awaitingReturn = false;

  constructor() {
    void this.store.ensureLoaded();
  }

  onManage(): void {
    this.awaitingReturn = true;
  }

  onVisibilityChange(): void {
    if (this.awaitingReturn && document.visibilityState === 'visible') {
      this.awaitingReturn = false;
      void this.droits.refresh();
    }
  }
}
